/**
 * Layout registry. One file per layout, resolved by name — never a switch
 * inside a shared file. Adding a layout means adding a file and one line here;
 * no caller changes.
 */

import { LAYOUT } from '../../model.js';
import * as standard from './standard.js';
import * as compact from './compact.js';
import * as minimal from './minimal.js';
import * as featured from './featured.js';
import * as profile from './profile.js';

const REGISTRY = {
	[LAYOUT.STANDARD]: standard,
	[LAYOUT.COMPACT]: compact,
	[LAYOUT.MINIMAL]: minimal,
	[LAYOUT.FEATURED]: featured,
	[LAYOUT.PROFILE]: profile,
};

export function renderLayout(model, ctx) {
	// An unknown layout renders as standard rather than throwing: a bad value
	// in a web-template field should not blank the block.
	const impl = REGISTRY[ctx.layout] || REGISTRY[LAYOUT.STANDARD];
	return impl.render(model, ctx);
}

export function hasLayout(name) {
	return Object.prototype.hasOwnProperty.call(REGISTRY, name);
}

export function layoutNames() {
	return Object.keys(REGISTRY);
}
